import { useEffect, useState } from "react";
import { DialogShell } from "../../../ui/DialogShell.js";

export interface ReasonDialogProps {
  readonly open: boolean;
  readonly title: string;
  readonly confirmLabel: string;
  readonly busy: boolean;
  readonly onClose: () => void;
  readonly onConfirm: (reason: string) => void;
  readonly testId?: string;
}

export function ReasonDialog(props: ReasonDialogProps) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (props.open) {
      setReason("");
    }
  }, [props.open]);

  return (
    <DialogShell
      open={props.open}
      title={props.title}
      onClose={props.onClose}
      testId={props.testId ?? "reason-dialog"}
      footer={
        <>
          <button
            type="button"
            className="pwz-btn pwz-btn-secondary"
            onClick={props.onClose}
            disabled={props.busy}
          >
            Назад
          </button>
          <button
            type="button"
            className="pwz-btn pwz-btn-primary"
            data-testid="reason-confirm"
            disabled={props.busy || reason.trim().length === 0}
            onClick={() => props.onConfirm(reason.trim())}
          >
            {props.busy ? "Выполняется…" : props.confirmLabel}
          </button>
        </>
      }
    >
      <label className="block text-sm">
        <span className="pwz-eyebrow mb-1.5 block">Причина — обязательно</span>
        <textarea
          className="pwz-field min-h-24"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          data-testid="field-structured-reason"
          required
        />
      </label>
    </DialogShell>
  );
}
